
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"21","height":"20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('mask',{staticStyle:{"mask-type":"alpha"},attrs:{"id":"a","maskUnits":"userSpaceOnUse","x":"0","y":"0","width":"21","height":"20"}},[_c('path',{attrs:{"fill":"#D9D9D9","d":"M.333 0h20v20h-20z"}})]),_c('g',{attrs:{"mask":"url(#a)"}},[_c('path',{attrs:{"d":"M11.167 14.208a9.158 9.158 0 011.844-.656 8.549 8.549 0 013.375-.094c.479.084.961.209 1.448.375v-8.25a7.22 7.22 0 00-1.427-.437 7.682 7.682 0 00-3.428.104 7.137 7.137 0 00-1.812.75v8.208zm-.833 2.459a7.998 7.998 0 00-2.167-1.23A6.829 6.829 0 005.75 15c-.583 0-1.156.076-1.719.23-.562.152-1.1.367-1.614.645-.292.153-.573.146-.844-.02a.805.805 0 01-.406-.73V5.083c0-.153.038-.298.114-.437a.72.72 0 01.344-.313c.653-.32 1.323-.566 2.01-.74a8.603 8.603 0 012.115-.26 8.984 8.984 0 014.583 1.25 8.986 8.986 0 014.584-1.25c.722 0 1.427.087 2.115.26.687.174 1.357.42 2.01.74a.72.72 0 01.344.313.895.895 0 01.114.437v10.042c0 .32-.135.562-.406.73-.27.166-.552.173-.844.02a7.541 7.541 0 00-1.614-.646 6.528 6.528 0 00-1.72-.23c-.832 0-1.638.147-2.416.438-.778.292-1.5.702-2.166 1.23z","fill":"currentColor"}})])])
          )
        }
      }
    